import React from 'react';
import FJLocalStore from '../../../store/FJLocalStore.js';
import WrongIcon from '../../../assets/oops.svg?react';
import EmptyIcon from '../../../assets/empty.svg?react';
import classNames from 'classnames';
import styles from './FJNoResults.module.less';

// 搜索为空是 WrongIcon， 列表本身为空是 EmptyIcon

const FJNoResults = props => {
    const { className, style, isSearchEmpty = true, text, keywords } = props;

    const textContent = !!text
        ? text
        : !!keywords
        ? FJLocalStore._('no-results-for') + ' "' + keywords + '"'
        : FJLocalStore._('could-not-load-results');
    return (
        <div className={classNames(styles.box, className)} style={style}>
            {isSearchEmpty ? <WrongIcon /> : <EmptyIcon />}
            <span className={styles.text}>{textContent}</span>
        </div>
    );
};

export default FJNoResults;
